export enum VideoPubEvent {
    SUCCESS = 'success',
    ERROR = 'error',
    CONSENT_DIALOG = 'consentDialog',
    ICE_STATE = 'iceState',
    MEDIA_STATE = 'mediaState',
    WEBRTC_STATE = 'webrtcState',

    JOINED = 'joined',
    DESTROYED = 'destroyed',

    PUBLISHERS = 'publishers',
    LEAVING = 'leaving',
    UNPUBLISHED = 'unpublished',
    ERROR_EVENT = 'error_event',

    ON_LOCAL_STREAM = 'onlocalstream',
    ON_CLEAN_UP = 'oncleanup',

    PUBLISHER_LEFT = 'publisherLeft',

    SET = 'set',
    CLEAR = 'clear'
}